import Page from "../../../../material/skeleton/Page";
import Header from "../../../../material/skeleton/Header";
import useAxiosConfigHeader from "../../../../use/useAxiosConfigHeader";
import {useNavigate, useParams} from "react-router";
import Menu from "./Menu";
import useInterventionRepository from "../../../../repository/b2c/useInterventionRepository";
import {useEffect, useState} from "react";
import isNull from "../../../../mixin/isNull";
import useOrderRepository from "../../../../repository/b2c/useOrderRepository";
import LoadingData from "../emergency/step/common/LoadingData";
import Modal from "../../../../material/modal/Modal";
import ModalConfig from "../../../../material/modal/ModalConfig";
import Create from "./message/Create";
import StepMain from "./step/StepMain";
import Intervention from "../../../../entity/b2c/Intervention";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import route from "../../../../enum/route";
import useSecurity from "../../../../use/useSecurity";
import Address from "./Address";

export default function () {
    const navigate = useNavigate();
    const security = useSecurity();
    const {token} = useParams();
    const headerConfigured = useAxiosConfigHeader("b2c", token);
    const interventionRepository = useInterventionRepository();
    const orderRepository = useOrderRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneByToken(token).select();
    /** @type Order */
    const order = orderRepository.findOneById(intervention?.getOrderId()).select();
    const [openAddress, setOpenAddress] = useState(false);
    const [openCreateMessage, setOpenCreateMessage] = useState(false);

    useEffect(() => {
        if (!headerConfigured) return;

        interventionRepository.findOneByToken(token).exec();
    }, [headerConfigured]);

    useEffect(() => {
        if (isNull(intervention) || !headerConfigured) return;

        orderRepository.findOneById(intervention.getOrderId()).exec();
    }, [JSON.stringify(intervention), headerConfigured]);

    const toggleOpenCreateMessage = o => () => setOpenCreateMessage(o);
    const toggleOpenAddress = o => () => setOpenAddress(o);
    const handleBack = () => navigate(route.ENTREPRENEUR_INTERVENTIONS);

    if (isNull(intervention) || isNull(order) || !headerConfigured) return <LoadingData/>;

    return (
        <Page>
            <Header>
                <Menu
                    orderId={order.getId()}
                    clientId={order.getClientId()}
                    onLetMessageClicked={toggleOpenCreateMessage(true)}
                    onOpenAddress={toggleOpenAddress(true)}
                />
            </Header>
            {
                intervention.getStatus() === Intervention.STATUS_IN_PROGRESS
                    ? <StepMain interventionId={intervention.getId()} orderId={order.getId()}/>
                    : null
            }

            {
                intervention.getStatus() === Intervention.STATUS_FAILED
                    ? (
                        <Box mt={20} px={2}>
                            <Typography variant="h6" textAlign={"center"}>
                                Intervention annulée
                            </Typography>
                            <Box mt={2}>
                                <Button
                                    startIcon={<ArrowBack/>}
                                    variant="contained"
                                    fullWidth
                                    onClick={handleBack}
                                >
                                    Retourner aux interventions
                                </Button>
                            </Box>
                        </Box>
                    )
                    : null
            }

            {
                intervention.getStatus() === Intervention.STATUS_SUCCESS
                || intervention.getStatus() === Intervention.STATUS_FORCED_SUCCESS
                    ? (
                        <Box mt={20} px={2}>
                            <Typography variant="h6" textAlign={"center"}>
                                Intervention terminée
                            </Typography>
                            <Box mt={2}>
                                <Button
                                    startIcon={<ArrowBack/>}
                                    variant="contained"
                                    fullWidth
                                    onClick={handleBack}
                                >
                                    Retourner aux interventions
                                </Button>
                            </Box>
                        </Box>
                    )
                    : null
            }

            {
                openCreateMessage
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setWidth("100%")
                                    .setHeight("60%")
                                    .setOnClose(toggleOpenCreateMessage(false))
                                    .setComponent(
                                        <Create
                                            interventionId={intervention.getId()}
                                            onSuccess={toggleOpenCreateMessage(false)}
                                        />
                                    )
                            }
                        />
                    )
                    : null
            }

            {
                openAddress
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setWidth("100%")
                                    .setHeight("100%")
                                    .setOnClose(toggleOpenAddress(false))
                                    .setComponent(
                                        <Address
                                            orderId={intervention.getOrderId()}
                                            clientId={order.getClientId()}
                                        />
                                    )
                            }
                        />
                    )
                    : null
            }
        </Page>
    )
}